import { State } from "./InspectorRow";
import { InspectorRowXL } from "./InspectorRowXL";
import { InspectorGroup } from "./InspectorGroup";
import { useTranslation } from "src/translations";

export const SustainabilityGroupLoading = () => {
  const { t } = useTranslation();
  return (
    <InspectorGroup label={t("sustainability.title")}>
      <InspectorRowXL state={State.LOADING} value={0} decimalPoint={3}>
        <span>{t("sustainability.indicativeFormFactor")}</span>
      </InspectorRowXL>
      <InspectorRowXL state={State.LOADING} value={0} decimalPoint={0} unit={t("units.kg")}>
        <span>{t("sustainability.co2Footprint")}</span>
      </InspectorRowXL>
      <InspectorRowXL state={State.LOADING} value={0} unit={t("units.kgSqm")} decimalPoint={0}>
        <span>{t("sustainability.co2FootprintPerArea")}</span>
      </InspectorRowXL>

      <InspectorRowXL state={State.LOADING} value={0} unit={t("units.kg")} decimalPoint={0}>
        <span>{t("sustainability.superstructureCo2")}</span>
      </InspectorRowXL>

      <InspectorRowXL state={State.LOADING} value={0} unit={t("units.kgSqm")} decimalPoint={0}>
        <span>{t("sustainability.superstructureCo2PerArea")}</span>
      </InspectorRowXL>
    </InspectorGroup>
  );
};
